// fiuhb_frontend/src/services/export_services/revenueExportService.js
import { API_BASE_URL } from '../../constants/appConstants';

const Finance_Base_Url = `${API_BASE_URL}/finances`;

// Revenue Export Services
export const exportRevenuePDF = async (revenueId, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/revenues/${revenueId}/download/pdf/?${params.toString()}`;
  
  try {
    const accessToken = localStorage.getItem('accessToken');
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
      },
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.error || 'Failed to export PDF'
      };
    }

    // Get the filename from Content-Disposition header
    const contentDisposition = response.headers.get('Content-Disposition');
    let filename = `revenue_${revenueId}.pdf`;
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1];
      }
    }

    // Get the blob
    const blob = await response.blob();

    // Create a download link and trigger it
    const url_blob = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url_blob;
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url_blob);

    return { success: true };
  } catch (error) {
    console.error('Error exporting revenue PDF:', error);
    return {
      success: false,
      error: error.message || 'An error occurred while exporting PDF'
    };
  }
};

export const exportRevenueExcel = async (revenueId, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/revenues/${revenueId}/download/excel/?${params.toString()}`;
  
  try {
    const accessToken = localStorage.getItem('accessToken');
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
      },
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.error || 'Failed to export Excel'
      };
    }

    // Get the filename from Content-Disposition header
    const contentDisposition = response.headers.get('Content-Disposition');
    let filename = `revenue_${revenueId}.xlsx`;
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1];
      }
    }

    // Get the blob
    const blob = await response.blob();

    // Create a download link and trigger it
    const url_blob = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url_blob;
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url_blob);

    return { success: true };
  } catch (error) {
    console.error('Error exporting revenue Excel:', error);
    return {
      success: false,
      error: error.message || 'An error occurred while exporting Excel'
    };
  }
};
// Export list of revenues as Excel with date range filtering
export const exportRevenuesListExcel = async (filters = {}, invitationId = null) => {
  const params = new URLSearchParams();
  
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  if (filters.start_date) {
    params.append('start_date', filters.start_date);
  }
  
  if (filters.end_date) {
    params.append('end_date', filters.end_date);
  }
  
  const url = `${Finance_Base_Url}/revenues/export/list/?${params.toString()}`;
  
  try {
    const accessToken = localStorage.getItem('accessToken');
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
      },
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.error || 'Failed to export revenues list'
      };
    }

    // Get the filename from Content-Disposition header
    const contentDisposition = response.headers.get('Content-Disposition');
    let filename = 'revenues_list';
    if (filters.start_date) {
      filename += `_from_${filters.start_date}`;
    }
    if (filters.end_date) {
      filename += `_to_${filters.end_date}`;
    }
    filename += '.xlsx';
    
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1];
      }
    }

    // Get the blob
    const blob = await response.blob();

    // Create a download link and trigger it
    const url_blob = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url_blob;
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url_blob);

    return { success: true };
  } catch (error) {
    console.error('Error exporting revenues list:', error);
    return {
      success: false,
      error: error.message || 'An error occurred while exporting revenues list'
    };
  }
};